import { Link } from "react-router-dom";
import { parseLinkedText } from "@/lib/internalLinks";

const DEFAULT_LINK_CLS =
  "font-semibold text-[#1E3A8A] underline decoration-[#1E3A8A]/30 underline-offset-2 hover:decoration-[#1E3A8A]";

/**
 * Renders CMS text containing [anchor](/page) links as crawlable <a href> anchors
 * (React Router <Link> renders a real <a href="/page">). Internal links open in the
 * same tab. Each destination is linked only once per block (or per `seen` set, if
 * the caller shares one across a page) to avoid overlinking; repeats stay plain text.
 */
export default function LinkedText({ text, as: Tag = "p", className = "", linkClassName = DEFAULT_LINK_CLS, seen, testId }) {
  if (!text) return null;
  const used = seen || new Set();
  const tokens = parseLinkedText(text);
  return (
    <Tag className={className} data-testid={testId}>
      {tokens.map((t, i) => {
        if (t.type === "text") return <span key={i}>{t.value}</span>;
        const url = (t.url || "").trim();
        const isInternal = url.startsWith("/") && !url.startsWith("//");
        if (!isInternal || used.has(url)) return <span key={i}>{t.anchor}</span>;
        used.add(url);
        return (
          <Link key={i} to={url} className={linkClassName} data-internal-link="true">
            {t.anchor}
          </Link>
        );
      })}
    </Tag>
  );
}
